import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';

/**
 * Activity Timer Route Guard Service
 * Starts the inactivity timer when entering routes that do not use DeviceRouteGuardService.
 * Use this guard on paths where the main app inactivity timeout should apply (e.g. login, survey flow, redirect).
 */
@Injectable({
  providedIn: 'root'
})
export class ActivityTimerRouteGuardService implements CanActivate {

  constructor(private authService: AuthService) {}

  canActivate(_route: ActivatedRouteSnapshot): boolean {
    // Force start on activity routes so timeout notification shows even when requireTimeout is false (e.g. in dev)
    this.authService.startInactivityTimer(true);
    return true;
  }
}
